import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["panel"];

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const isOpen = this.panelTarget.style.display === "block";

    document.querySelectorAll(".config-dropdown-panel").forEach((p) => {
      p.style.display = "none";
    });

    if (!isOpen) {
      this.panelTarget.style.display = "block";

      const closeOnOutsideClick = (e) => {
        if (!this.panelTarget.contains(e.target) && e.target !== event.currentTarget) {
          this.panelTarget.style.display = "none";
          document.removeEventListener("click", closeOnOutsideClick);
        }
      };
      setTimeout(() => {
        document.addEventListener("click", closeOnOutsideClick);
      }, 0);
    }
  }
}